import React from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import theme from "app/Theme/Theme";
import CheckBox from "@react-native-community/checkbox";
import { Platform } from "react-native";
import i18n from "@microdoing/shared/i18n";
import CommentBox from "app/scenes/FeedbackScreen/CommentBox";
import normalize from "app/utils/normalize";

export interface IOptionBar {
  text: string;
  isSelected: boolean;
  comment: string;
  onPress: () => void;
  setComment: (text: string) => void;
}

const OptionBar = ({
  text,
  comment,
  isSelected,
  setComment,
  onPress,
}: IOptionBar) => {
  return (
    <PressableOpacity
      onPress={onPress}
      style={{
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        padding="sm"
        backgroundColor="neutral.white"
        borderRadius={8}
        borderColor={isSelected ? "brand.500" : "neutral.transparent.white.80"}
        borderWidth={isSelected ? 2 : 1}
        marginBottom="sm"
      >
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <CheckBox
            onChange={Platform.OS === "android" ? onPress : () => {}}
            value={isSelected}
            boxType="square"
            onAnimationType="fill"
            offAnimationType="fill"
            tintColor={
              !isSelected
                ? theme.colors["neutral.600"]
                : theme.colors.transparent
            }
            onCheckColor={theme.colors["brand.500"]}
            onFillColor={
              isSelected ? theme.colors["brand.100"] : theme.colors["brand.500"]
            }
            onTintColor={
              isSelected ? theme.colors["brand.100"] : theme.colors["brand.500"]
            }
            style={{ width: 18, height: 18 }}
            color={theme.colors["brand.500"]}
          />
          <MainText variant="l4-medium" marginLeft="sm" color="neutral.900">
            {text}
          </MainText>
        </Box>
        {text === i18n.t("cancel-action-other-reason") && (
          <CommentBox
            style={{
              width: "100%",
              marginTop: theme.spacing.sm,
              color: theme.colors["neutral.900"],
            }}
            maxHeight={normalize(70)}
            onChangeText={setComment}
            value={comment}
            placeholder={i18n.t("comment")}
          />
        )}
      </Box>
    </PressableOpacity>
  );
};

export default OptionBar;
